import { MenuLeaf } from '../../../types/types';

// Unique sidebar identity for a leaf. Forms are namespaced so a form whose formId
// equals a dataset's url does not highlight both leaves. Datasets keep the bare url.
export const getMenuLeafKey = (leaf: MenuLeaf): string | undefined =>
  leaf.formId
    ? `form:${leaf.formId}`
    : leaf.appId
      ? `app:${leaf.appId}`
      : leaf.url;
